// extracted by mini-css-extract-plugin
export default {"block":"nl","select":"ol","empty":"pl","open":"ql","error":"rl","options":"sl","selectActive":"tl","ornament":"ul"};